import React from "react";
import Suspence from "Components/Layout/Suspence";
import { lazyLoader } from "Service/loader";
const OnboardingForm = lazyLoader(
  () => import("Containers/Register/RegisterStep3/OnboardingForm")
);

export const OnboardingFormPage = () => {
  return (
    <Suspence>
      <OnboardingForm />
    </Suspence>
  );
};
